import { prefixerM } from '.'

export const ROUTE_BANCOS = prefixerM('bancos')
export const ROUTE_CUENTA_BANCARIAS = prefixerM('cuentas-bancarias')
